//#region types
import { DialogEnums } from "models/enums";
import { DateRange } from "models/formTypes/util";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import ReApproveSalaryPreview from "./_partials/reApproveSalaryPreview";
import ReApprovePreview from "./_partials/reApprovePreview";
import { ReApproveProvider } from "./context/reApproveContext";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { useWintSalaryService } from "serviceHooks";

function useSalaryReApproveDialog() {
  const { approveSalaryMonth } = useWintSalaryService();

  const getReApproveDialog = (
    personId: number,
    personName: string,
    yearMonth: number,
    shownChanges: boolean,
    currentDeviationDateRange?: DateRange,
    previousDeviationDateRange?: DateRange,
    onApproveSuccess?: () => void
  ): DialogProps => {
    const onApprove = async () => {
      await approveSalaryMonth({
        personIds: [personId],
        yearAndMonth: yearMonth,
      });
    };

    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.SalaryDeviation.ReApproveSalaryPreviewTitle
      ),
      titleIcon: IconDefinitionConstants.WIncome2,
      dialogType: DialogEnums.DialogType.Content,
      children: (
        <ReApproveSalaryPreview
          personName={personName}
          currentDeviationDateRange={currentDeviationDateRange}
          previousDeviationDateRange={previousDeviationDateRange}
          shownChanges={shownChanges}
        />
      ),
      maxWidth: "sm",
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SalaryDeviation.ReApproveSalaryPreviewSave
          ),
          successMessage: TranslationKeys.SalaryDeviation.ReApproveSuccessMessage,
          onClick: onApprove,
        },
      ],
      previewElement: <ReApprovePreview />,
      contextProvider: ReApproveProvider,
      contextProviderProps: { personId, yearMonth },
      onSubmit: onApproveSuccess,
    };
  };
  return getReApproveDialog;
}

export default useSalaryReApproveDialog;
